(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["relevia-home"] && !Shopify.designMode) return;
  try {
    
function initReleviaHome(root){
 root.querySelectorAll('.rh-community').forEach(section=>{if(section.dataset.galleryReady)return;section.dataset.galleryReady='true';const track=section.querySelector('.rh-photo-strip');const buttons=[...section.querySelectorAll('[data-rh-scroll]')];function update(){buttons.forEach(b=>{b.disabled=Number(b.dataset.rhScroll)<0?track.scrollLeft<2:track.scrollLeft+track.clientWidth>=track.scrollWidth-2;});}buttons.forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.rhScroll)*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));track.addEventListener('scroll',update,{passive:true});if(window.ResizeObserver)new ResizeObserver(update).observe(track);update();});
 root.querySelectorAll('.rh-moments').forEach(section=>{if(section.dataset.posterReady)return;section.dataset.posterReady='true';const dialog=section.querySelector('dialog');let trigger;section.querySelectorAll('[data-rh-enlarge]').forEach(button=>button.addEventListener('click',()=>{trigger=button;const image=button.querySelector('img');const preview=dialog.querySelector('img');preview.src=image.currentSrc||image.src;preview.alt=image.alt;dialog.showModal();}));dialog.querySelector('.rh-dialog-close').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog){const rect=dialog.getBoundingClientRect();if(e.clientX<rect.left||e.clientX>rect.right||e.clientY<rect.top||e.clientY>rect.bottom)dialog.close();}});dialog.addEventListener('close',()=>trigger?.focus());});
root.querySelectorAll('.rh-science').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const tabs=[...section.querySelectorAll('[role=tab]')];function activate(tab){tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;section.querySelector('#'+t.getAttribute('aria-controls')).hidden=!active;});}tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activate(tab));tab.addEventListener('keydown',e=>{let next;if(e.key==='ArrowRight')next=(i+1)%tabs.length;else if(e.key==='ArrowLeft')next=(i-1+tabs.length)%tabs.length;else if(e.key==='Home')next=0;else if(e.key==='End')next=tabs.length-1;else return;e.preventDefault();activate(tabs[next]);tabs[next].focus();});});});}
initReleviaHome(document);document.addEventListener('shopify:section:load',e=>initReleviaHome(e.target));document.addEventListener('shopify:block:select',e=>{const panel=e.target.closest('[role=tabpanel]');if(panel)document.getElementById(panel.getAttribute('aria-labelledby'))?.click();const details=e.target.closest('details');if(details)details.open=true;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["relevia-moments"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('relevia-moments')) {
  customElements.define('relevia-moments', class extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const signal = this._controller.signal;
      const track = this.querySelector('.rm-track');
      const cards = [...this.querySelectorAll('[data-moment]')];
      const dots = [...this.querySelectorAll('[data-moment-dot]')];
      const previous = this.querySelector('[data-moment-direction="-1"]');
      const next = this.querySelector('[data-moment-direction="1"]');
      if (!track || cards.length < 2) return;
      const leftOf = card => card.offsetLeft - cards[0].offsetLeft;
      const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
      const position = () => cards.reduce((nearest, card, index) => Math.abs(Math.min(leftOf(card), maxScroll()) - track.scrollLeft) < Math.abs(Math.min(leftOf(cards[nearest]), maxScroll()) - track.scrollLeft) ? index : nearest, 0);
      const update = () => {
        const max = maxScroll();
        previous.hidden = next.hidden = max < 2;
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft >= max - 2;
        this.querySelector('.rm-dots').hidden = max < 2;
        const finalStart = cards.findIndex(card => leftOf(card) >= max - 1);
        const finalIndex = finalStart < 0 ? cards.length - 1 : finalStart;
        const active = Math.min(position(), finalIndex);
        dots.forEach((dot, index) => {
          dot.hidden = index > finalIndex;
          dot.setAttribute('aria-pressed', String(index === active));
        });
      };
      const go = index => {
        const safeIndex = Math.max(0, Math.min(cards.length - 1, index));
        track.scrollTo({left: Math.min(leftOf(cards[safeIndex]), maxScroll()), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      previous.addEventListener('click', () => go(position() - 1), {signal});
      next.addEventListener('click', () => go(position() + 1), {signal});
      dots.forEach((dot, index) => dot.addEventListener('click', () => go(index), {signal}));
      track.addEventListener('scroll', update, {signal, passive: true});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        go(position() + (event.key === 'ArrowRight' ? 1 : -1));
      }, {signal});
      document.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-moment]');
        if (card && this.contains(card)) go(Number(card.dataset.moment));
      }, {signal});
      this._observer = new ResizeObserver(update);
      this._observer.observe(track);
      update();
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._controller = null;
      this._observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["relevia-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('relevia-product-gallery')) {
 customElements.define('relevia-product-gallery', class extends HTMLElement {
  connectedCallback() {
   if (this._controller) return;
   this._controller = new AbortController();
   const signal = this._controller.signal;
   const thumbs = [...this.querySelectorAll('[data-thumb]')];
   const stage = this.querySelector('.gallery-stage');
   const strip = this.querySelector('.gallery-thumbs');
   const nav = this.querySelector('.rv-gallery-navigation');
   const count = this.querySelector('[data-gallery-count]');
   if (thumbs.length < 2 || !nav) return;
   nav.hidden = false;
   const selected = () => Math.max(0, thumbs.findIndex(t => t.getAttribute('aria-pressed') === 'true'));
   const sync = () => {
    const index = selected();
    count.textContent = `${index + 1} / ${thumbs.length}`;
    const active = thumbs[index];
    const target = active.offsetLeft - thumbs[0].offsetLeft - (strip.clientWidth - active.offsetWidth) / 2;
    strip.scrollTo({left: Math.max(0, target), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
   };
   const step = delta => thumbs[(selected() + delta + thumbs.length) % thumbs.length].click();
   this.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => step(Number(button.dataset.galleryStep)), {signal}));
   let start = null;
   stage.addEventListener('touchstart', event => { start = {x:event.changedTouches[0].clientX,y:event.changedTouches[0].clientY}; }, {signal,passive:true});
   stage.addEventListener('touchend', event => {
    if (!start) return;
    const dx=event.changedTouches[0].clientX-start.x, dy=event.changedTouches[0].clientY-start.y;
    if (Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)*1.5) step(dx<0?1:-1);
    start=null;
   }, {signal,passive:true});
   this._observer = new MutationObserver(sync);
   this._observer.observe(strip, {subtree:true, attributes:true, attributeFilter:['aria-pressed']});
   sync();
  }
  disconnectedCallback() { this._controller?.abort();this._controller=null;this._observer?.disconnect(); }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["relevia-reviews"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('relevia-review-carousel')) {
  customElements.define('relevia-review-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const signal = this._controller.signal;
      const track = this.querySelector('.rr-track');
      const cards = [...this.querySelectorAll('[data-review]')];
      const dots = [...this.querySelectorAll('[data-review-dot]')];
      const previous = this.querySelector('[data-review-direction="-1"]');
      const next = this.querySelector('[data-review-direction="1"]');
      if (!track || cards.length < 2) return;
      const leftOf = card => card.offsetLeft - cards[0].offsetLeft;
      const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
      const position = () => cards.reduce((nearest, card, index) => Math.abs(Math.min(leftOf(card), maxScroll()) - track.scrollLeft) < Math.abs(Math.min(leftOf(cards[nearest]), maxScroll()) - track.scrollLeft) ? index : nearest, 0);
      const update = () => {
        const max = maxScroll();
        previous.hidden = next.hidden = max < 2;
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft >= max - 2;
        this.querySelector('.rr-dots').hidden = max < 2;
        const finalStart = cards.findIndex(card => leftOf(card) >= max - 1);
        const finalIndex = finalStart < 0 ? cards.length - 1 : finalStart;
        const active = Math.min(position(), finalIndex);
        dots.forEach((dot, index) => {
          dot.hidden = index > finalIndex;
          dot.setAttribute('aria-pressed', String(index === active));
        });
      };
      const go = index => {
        const safeIndex = Math.max(0, Math.min(cards.length - 1, index));
        track.scrollTo({left: Math.min(leftOf(cards[safeIndex]), maxScroll()), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      previous.addEventListener('click', () => go(position() - 1), {signal});
      next.addEventListener('click', () => go(position() + 1), {signal});
      dots.forEach((dot, index) => dot.addEventListener('click', () => go(index), {signal}));
      track.addEventListener('scroll', update, {signal, passive: true});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        go(position() + (event.key === 'ArrowRight' ? 1 : -1));
      }, {signal});
      document.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-review]');
        if (card && this.contains(card)) go(Number(card.dataset.review));
      }, {signal});
      this._observer = new ResizeObserver(update);
      this._observer.observe(track);
      update();
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._controller = null;
      this._observer?.disconnect();
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
